module.exports = __webpack_public_path__ + "media/images/vp/icon.vote.smile-2-464a2cceaf504d0195502ba29bb2b590.svg";